var StreamHandler = function () {
    this.failCount = 0;
    this.msgCount = 0;
    this.queryParams = {
        exclude_archives: '1'
    };
};
StreamHandler.prototype = $.extend({
    reset: function () {
        // Reset in 10 seconds, gives us time to clear it onError
        if (this.failCount) {
            this.clearResetTimeout();
            this.resetTimeout = setTimeout(_.bind(function () {
                debug.log('Handler', 'reset', '(failCount: ' + this.failCount + ')');
                this.failCount = 0;
                this.resetTimeout = null;
            }, this), 10000);
        }
    },
    clearResetTimeout: function () {
        if (this.resetTimeout) {
            clearTimeout(this.resetTimeout);
            this.resetTimeout = null;
        }
    },
    getQueryString: function () {
        var qs = $.param(this.queryParams);
        return qs ? '?' + qs : '';
    },
    setQueryParam: function (key, value) {
        var params;
        // Single arg means full pref object
        if (arguments.length === 2) {
            params = {};
            params[key] = value;
        } else {
            params = key;
        }
        var previousValue;
        var v;
        var newParams = $.extend(true, {}, this.queryParams);
        for (var k in params) {
            v = params[k];
            previousValue = newParams[k];
            if (v) {
                if (!_.isEqual(v, previousValue)) {
                    newParams[k] = v;
                }
            } else {
                if (previousValue) {
                    delete newParams[k];
                }
            }
        }
        this.queryParams = newParams;
    },
    onDisconnect: function () {
        if (this.msgCount === 0) {
            this.onNoData();
        } else {
            // Connection closed
            this.trigger('disconnect', this.failCount);
        }
    },
    onConnectionError: function () {
        if (this.msgCount === 0) {
            this.onNoData();
        } else {
            this.trigger('connectionError');
        }
    },
    onNoData: function () {
        debug.log('Handler', 'onNoData');
        // Connection closed with no data
        this.trigger('noData', this.failCount);
    },
    onError: function () {
        // Bump the error count
        this.failCount++;
        this.clearResetTimeout();
        debug.warn('Handler', 'onError', '(failCount: ' + this.failCount + ')');
    },
    onMessage: function (message) {
        this.msgCount++;
        this.trigger('message', message);
    },
    start: function () {
        debug.group('handler start');
        if (this.isSocket()) {
            debug.warn('Handler', 'exists', this.getHandler(), '(readystate: ' + this._getReadyState() + ')');
            this.close();
        } else {
            debug.group('open stream');
            this.connect();
            debug.groupEnd();
        }
        debug.groupEnd();
    },
    stop: function () {
        debug.group('handler stop');
        this.trigger('stop');
        if (this.isSocket()) {
            this.close();
        } else {
            this.trigger('disconnect');
        }
        debug.groupEnd();
    },
    error: function () {
        debug.group('handler error');
        this.trigger('stop');
        this.close(true);
        debug.groupEnd();
    },
    connect: function () {
        debug.warn('connect() called on abstract StreamHandler instance');
    },
    getHandler: function () {
        debug.warn('getHandler() called on abstract StreamHandler instance');
    },
    isOpen: function () {
        debug.warn('isOpen() called on abstract StreamHandler instance');
    },
    isConnecting: function () {
        debug.warn('isConnecting() called on abstract StreamHandler instance');
    },
    close: function () {
        debug.warn('close() called on abstract StreamHandler instance');
    },
    parseJsonMessage: function (json) {
        // Throws exception on parse error, caught higher up
        var message = JSON.parse(json);
        if (message._reqid) {
            if (message.success) {
                debug.log('<- [' + message._reqid + ' SOCK]', 'success', message);
            } else {
                debug.warn('<- [' + message._reqid + ' SOCK]', 'failed', message);
            }
        } else if (message.bid > 0) {
            debug.log('[' + message.cid + ' ' + message.bid + ' ' + message.type + ']', message);
        } else if (message.cid) {
            debug.log('[' + message.cid + ' ' + message.type + ']', message);
        } else if (message.type) {
            debug.log('[' + message.type + ']', message);
        } else {
            debug.log(message);
        }
        return message;
    }
}, Backbone.Events);


module.exports = StreamHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/streamhandler.js
// module id = oPQz
// module chunks = 1